// extracted by mini-css-extract-plugin
module.exports = {"layout":"BodySubMain_layout_AbSQG"};